export const trackPromise =
    (start: () => void, stop: () => void) =>
    async <T>(p: Promise<T>): Promise<T> => {
        start();
        try {
            const v = await p;
            return v;
        } finally {
            stop();
        }
    };
